import { isEmpty } from 'lodash';

const checkFormUpsertValidation = ({ formField, errors }) => {
  return (
    !isEmpty(formField?.name) &&
    !isEmpty(formField?.room) &&
    !isEmpty(formField?.address) &&
    !isEmpty(formField?.appType) &&
    !isEmpty(formField?.area) &&
    isEmpty(errors)
  );
};

export default checkFormUpsertValidation;
